<template>
  <v-container>
    <div class="page download">
      <v-row>
        <v-col align="center" class="d-flex justify-center align-center">
          <v-fade-transition leave-absolute>
          <v-card v-show="successfully" class="download_successfully">
            <br>
            <v-icon size="66" color="#00DD55"
                >mdi-check-circle</v-icon
              >
              <br>
            <h4>{{ $t('download.successfully') }}</h4>
            <h5>{{ $t('download.thank') }}</h5>
            <v-btn
              text
              v-text="$t('download.back')"
              :to="`/optimization/${id}`"
            ></v-btn>
          </v-card>
          </v-fade-transition>
          <v-card :class="{'px-sm-16': true, 'download_hide': successfully}">
            <v-card-title class="my-4 justify-center">
              <span v-text="$t('optimization.download_to_email')"></span>
            </v-card-title>
            <v-card-text>
              <v-form
                ref="form"
                lazy-validation
                @submit.prevent="send"
                class="sign_form"
              >
                <v-text-field
                  v-model="email"
                  :disabled="applying"
                  :label="$t('download.email')"
                  prepend-inner-icon="mdi-email-outline"
                  type="text"
                  name="virtualman_email"
                  id="virtualman_email"
                  :rules="Object.values(rules)"
                ></v-text-field>
                <div class="subscribe my-8">
                  <v-checkbox
                    v-model="subscribe"
                    :disabled="applying"
                    :counter="30"
                    :label="$t('download.subscribe')"
                  ></v-checkbox>
                </div>
                <v-btn
                  depressed
                  block
                  tile
                  color="primary"
                  @click="send"
                  :disabled="applying"
                  :loading="applying"
                  v-text="$t('download.download')"
                  class="btn_download2 mb-4"
                >
              </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Download",
  data() {
    return {
      email: null,
      subscribe: true,
      applying: false,
      successfully: false,
      rules: [
        (value) => !!value || this.$t("download.required"),
        (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("auth.invalid_email");
        },
      ],
    };
  },
  computed:{
    id(){
      return this.$route.params.id || null;
    }
  },
  methods: {
    send() {
      if (!this.$refs.form.validate() || this.applying || this.id == null ) {
        return;
      }
      this.applying = true;
      this.$ajax(this.$root.api + '/send', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        data: {
          email: this.email,
          trial: this.subscribe,
          reportId: this.id
        }
      })
        .then(res => {
          if (res.data == true) {
            this.successfully = true;
            this.applying = false;
          }else{
            this.applying = false;
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  mounted(){
    // if(this.screening == null && eid != undefined) {
    //   this.$db.ref(`optimization/${eid}`).on('value', snapshot => {
    //     if (!snapshot.exists()){
    //       this.$router.push(`/start`);
    //     }
    //     this.screening = snapshot.val() || {};
    //   });
    // }
  }
};
</script>
